<template>
    <div class="controlForm">
        <div class="filterBox">
            <!-- <Form :form="form_data_seo" @search="onSearch"> </Form> -->
			<Form class="ant-advanced-search-form" :form_data="form_data_seo" ref="form_seo" @handleSubmit="handleSubmit"
				@handleReset="handleReset" 
				>
			</Form>
        </div>
        <div class="tableBox">
            <div class="t_b_content">
                <div class="t_b_c_box" v-for='list in data'>
                    <div class="t_b_c_b_head">
                        {{list.title}}
                    </div>
                    <div class="t_b_c_b_table">
                        <a-table :pagination='false' :columns="columns" :data-source="list.data">
                            <span slot="oeprs" slot-scope="text, record">
                                <a  v-auth="'setting'" @click="edit(record)">配置</a>
                                <a-divider type="vertical" v-if='record.status==1' />
                                <a  v-auth="'change'" @click="editConfig(record)" v-if='record.status==1'>填写</a>
                            </span>
                        </a-table>
                    </div>
                </div>
            </div>
        </div>
		
		<EditPop @handleSubmit="submit" :form_data="form_data" :visible.sync="visible">
			
		</EditPop>
    </div>
</template>

<script>
	import { 	getTemplateCate,getTemplateList,saveTemplateConfig,getTemplateType } from "@/api/quality";
    import Form from '@/components/Form'
	import EditPop from "@/components/EditPop";
	
	 // import MineralWaterFactoryInspectionReport from '..//FilterForm'
	
    export default {
        components: {
            Form,EditPop
        },
        data() {
            return {
				visible:false,
				form_data:{
					title: '添加',
				    list: [
				        {
				            type: 'text',
				            name: 'id',
				            hidden: true,
				            options: {},
				        },
						
						
						{
						    type: 'text',
						    name: 'default_title',
						    title: '表类型',
						    options: {},
							disabled:true,
							
						},
						{
						    type: 'text',
						    name: 'title',
						    title: '检验表名称',
						    options: {},
						},
				       
				        {
				            type: 'radio',
				            name: 'status',
				            title: '状态',
				            list: [
				                {
				                    key: 0,
				                    value: "禁用"
				                },
				                {
				                    key: 1,
				                    value: "启用"
				                }
				            ],
				            options: {},
				        },
						{
						    type: 'text',
						    name: 'describe',
						    title: '表单描述',
						    options: {},
						},
						{
						    type: 'radio',
						    name: 'is_limit',
						    title: '启动阈值提醒',
						    list: [
						        {
						            key: 0,
						            value: "否"
						        },
						        {
						            key: 1,
						            value: "是"
						        }
						    ],
						    options: {},
						},
				        {
				            type: 'text',
				            name: 'auto_submit_time',
				            title: '自动提交时间',
				            options: {},
							suffix:'小时'
				        },
				    ]
				},
				
				cate_id:'',
				keyword:'',
				template_tab:[],
               form_data_seo: {
               	list: [
               
               		{
               			type: "text",
               			name: "keyword",
               			title: "名称",
               			placeholder: '请输入',
               			options: {
               
               			}
               		},
               
               		{
               			 type: "tree-select",
               			name: "cate_id",
               			title: "类型",
               			options: {},
               			treeData: [],
               			replaceFields: {
               			    label: "name",
               			    value: "id",
               			    children: "sub"
               			},
               		},
               	],
               	...this.$config.form_data_seo
               },
               
                data: [],
                columns: [{
                    dataIndex: 'title',
                    key: 'title',
                    title: '检验表名称',
					width: 300,
                }, {
                    dataIndex: 'describe',
                    key: 'describe',
                    title: '描述',
					// width:300,
                }, {
                    dataIndex: 'oeprs',
                    key: 'oeprs',
                    title: '操作',
					 width: 200,
                    scopedSlots: {
                        customRender: 'oeprs'
                    },
                }]
            }
        },
		async created() {
		    this.getTemplateCate();
			
			getTemplateType().then(res=>{
				this.form_data_seo.list[1].treeData = res.data.list
			})
		},
        methods: {
			edit(record){
				this.form_data.title = "配置"
				let data = record
			    this.form_data.list.forEach(item => {
			        item.options.initialValue = data[item.name];
			    })
			    this.visible = true;
			},
			submit(e) {
			    let data = e.values;
			    if (!data.id) {
			        data.id = '';
			    }
			    saveTemplateConfig({
			        data: {
			            ...data,
					},
					info:true
			    }).then(res => {
					this.visible = false;
					this.getTemplateList()
			    })
			
			},
			handleReset(e){
				this.keyword=''
				this.cate_id=''
				this.getTemplateList()
			},
            handleSubmit(e) {
				this.keyword=e.values.keyword
				this.cate_id=e.values.cate_id
				this.getTemplateList()
            },
			getTemplateList(){
				getTemplateList({data:{
					cate_id:this.cate_id,
					keyword:this.keyword
				}}).then(res=>{
					this.data = res.data.list
				})
			},
			getTemplateCate(){
				getTemplateCate().then(res=>{
					this.template_tab = res.data.list
					this.getTemplateList()
				})
			},
            editConfig(e){
                this.$router.push({
                    path: '/control/form/info',
                    query: {
                        template_id: e.id,
						type:1,
						can_change:e.can_change,
						p_type:e.type
                    }
                })
            },
			
        }
    }
</script>

<style scoped lang="less">
    .controlForm {
        padding: 15px;
    }

    .filterBox {
        background-color: #fff;
		padding:12px;
		 padding-bottom: 0;
        .form {
            padding: 15px;
            padding-bottom: 0;
        }
    }

    .tableBox {
        margin-top: 15px;
        background-color: #fff;
        padding: 15px;

        .t_b_tab {
            display: flex;
            align-items: center;

            .title {
                font-size: 14px;
                color: #333;
            }

            .t_b_t_tab {
                display: flex;
                align-items: center;
                gap: 12px;
                color: #333;

                div {
                    cursor: pointer;
                }

                .active {
                    color: #1890ff;
                    font-weight: bold;
                }
            }
        }

        .t_b_content {
            .t_b_c_box {
                margin-top: 15px;

                .t_b_c_b_head {
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                    color: #333;
                    gap: 8px;

                    &::before {
                        content: ' ';
                        display: block;
                        width: 4px;
                        height: 15px;
                        background-color: #1890ff;
                    }
                }

                .t_b_c_b_table {
                    margin-top: 10px;
                }

            }
        }
    }
</style>